import React, { useEffect, useState, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetQuestionsByFlowQuery } from "../../../../../store/api/useQuestion";
import { message } from "antd";
import CustomAlertModal from "./CustomAlertModal";
import InformationCircleIcon from "../../../../../assets/icons/img.png"; // Adjust the path if needed
import axios from "axios"; // Ensure axios is installed
import { useCreateAnswerMutation } from "../../../../../store/api/useAnswersApi";
import SavingsModal from "./SavingsModal"; // adjust path if needed
import RefundModal from "./RefundModal"; // adjust path if needed
import RefundAmountModal from "./RefundAmountModal"; // adjust path if needed
import AppInstallModal from "./AppInstallModal"; // adjust path if needed
import SuggestionTaxSavingModal from "./SuggestionTaxSavingModal";
import {
  createRefundEstimation,
  patchRefundEstimation,
  REFUND_FLOW_ID,
  refundEstimationFieldMap,
  buildRefundEstimationPayload,
} from "./refundEstimationApi";

const SAVINGS_FLOW_ID = "688a0e2564d03f7782f0910a";

const QuestionsPage = () => {
  const { id: flowId } = useParams();
  const params = useParams();
  const [activeFlowId, setActiveFlowId] = useState(params.id);
  const [isPageVisible, setIsPageVisible] = useState(false);

  const navigate = useNavigate();
  const { data: questionsData, isLoading } =
    useGetQuestionsByFlowQuery(activeFlowId);
  const [showModal, setShowModal] = useState(false);
  const [createAnswer, { isLoading: isSubmitting }] = useCreateAnswerMutation();
  const token = localStorage.getItem("extarrnalToken"); // OR get from Redux if persisted
  const [step, setStep] = useState(1); // start at step 1
  const estimationId = localStorage.getItem("estimationId"); // or wherever you store the JWT
  const [localXhrParams, setLocalXhrParams] = useState({});
  const [annualSaving, setAnnualSaving] = useState(null);
  const [spendPerDay, setSpendPerDay] = useState(null);
  const [refund, setRefund] = useState(null);
  const [refundYears, setRefundYears] = useState(null);
  const [totalExpenses, setTotalExpenses] = useState(null);
  const [completedRefundAmount, setCompletedRefundAmount] = useState(null);
  const lastRefundFromApiRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [nextFlowId, setNextFlowId] = useState(null);
  const [isModalSavinglOpen, setIsModalSavinglOpen] = useState(false);
  const [isRefundModalOpen, setIsRefundModalOpen] = useState(false);
  const [showSavingsFlowButtonInRefundModal, setShowSavingsFlowButtonInRefundModal] = useState(false);
  const [isRefundAmountModalOpen, setIsRefundAmountModalOpen] = useState(false);
  const [isAppInstallModalOpen, setIsAppInstallModalOpen] = useState(false);
  const [isSuggestionTaxSavingOpen, setIsSuggestionTaxSavingOpen] = useState(false);
  const [isNextLoading, setIsNextLoading] = useState(false);
  const [isSuggestionStartLoading, setIsSuggestionStartLoading] = useState(false);
  const [inputErrors, setInputErrors] = useState({});

  const isSavingsIncomeSingleSelect = (question) =>
    activeFlowId === SAVINGS_FLOW_ID && String(question?.ref || "") === "1";

  const handleNavigateFlow = async () => {
    if (nextFlowId) {
      if (nextFlowId === REFUND_FLOW_ID) {
        try {
          const data = await createRefundEstimation();
          const id = data.id || data._id;
          if (id) localStorage.setItem("refundEstimationId", id);
        } catch (err) {
          console.error("Failed to create refund estimation:", err);
          message.error("Failed to start refund. Please try again.");
          return;
        }
      }
      setActiveFlowId(nextFlowId);
      setStep(1);
      setCurrentQuestionId(null);
      setNextFlowId(null);
      setIsModalOpen(false);
      setIsModalSavinglOpen(false);
      setIsRefundModalOpen(false);
      setIsRefundAmountModalOpen(false);
      setIsSuggestionTaxSavingOpen(false);
    }
  };

  const handleStartSavingsFlow = async () => {
    setIsSuggestionStartLoading(true);
    const switchToSavingsQuestions = () => {
      setActiveFlowId(SAVINGS_FLOW_ID);
      setStep(1);
      setCurrentQuestionId(null);
      setAnswers({});
      setLocalXhrParams({});
      setAnnualSaving(null);
      setSpendPerDay(null);
      setRefund(null);
      setRefundYears(null);
      setTotalExpenses(null);
      setCompletedRefundAmount(null);
      lastRefundFromApiRef.current = null;
      setIsModalOpen(false);
      setNextFlowId(null);
      setIsModalSavinglOpen(false);
      setIsRefundModalOpen(false);
      setShowSavingsFlowButtonInRefundModal(false);
      setIsRefundAmountModalOpen(false);
      setIsAppInstallModalOpen(false);
      setIsSuggestionTaxSavingOpen(false);
      navigate(`/preview/flow/${SAVINGS_FLOW_ID}/question`, { replace: true });
    };

    try {
      const payload = {
        startDate: new Date().toISOString(),
        user: "6899eb6eebdd7e9cc42384da",
        income: null,
        source: "Mobile app",
        status: "In progress",
        ownCar: null,
        mileage: null,
        mileageRate: null,
        foodAndDrink: null,
        daysPerWeek: null,
        reimbursedPerDay: null,
        annualSaving: null,
        trialStarted: null,
        refundYears: 0,
        refund: null,
        onBoardingStatut: null,
        timeSpent: 0,
        mileageType: 0,
        spendPerDay: 0,
        annualExpenses: 0,
      };
      const response = await axios.post(
        "https://api.savyapp.dev/api/v1/estimations/user/me",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newEstimationId = response.data.id;
      if (!newEstimationId) {
        throw new Error("Savings estimation id was not returned");
      }
      localStorage.setItem("estimationId", newEstimationId);
      localStorage.removeItem("refundEstimationId");
      switchToSavingsQuestions();
    } catch (err) {
      console.error("Failed to start savings flow:", err);
      message.error("Failed to initialize savings estimation. Please try again.");
    } finally {
      setIsSuggestionStartLoading(false);
    }
  };

  const handleRestartFlow = async () => {
    console.log(
      "🔍 handleRestartFlow called - restarting refund estimation flow"
    );

    try {
      const data = await createRefundEstimation();
      const newRefundEstimationId = data.id || data._id;
      if (newRefundEstimationId) {
        localStorage.setItem("refundEstimationId", newRefundEstimationId);
      }
      localStorage.removeItem("estimationId");

      // Keep user in refund flow and restart from first question
      setActiveFlowId(REFUND_FLOW_ID);
      setStep(1);
      setCurrentQuestionId(null);
      setAnswers({});
      setLocalXhrParams({});
      setAnnualSaving(null);
      setSpendPerDay(null);
      setRefund(null);
      setRefundYears(null);
      setTotalExpenses(null);
      setCompletedRefundAmount(null);
      lastRefundFromApiRef.current = null;
      setIsModalOpen(false);
      setNextFlowId(null);
      setIsModalSavinglOpen(false);
      setIsRefundModalOpen(false);
      setIsRefundAmountModalOpen(false);
      setIsAppInstallModalOpen(false);
      setIsSuggestionTaxSavingOpen(false);

      navigate(`/preview/flow/${REFUND_FLOW_ID}/question`, { replace: true });
      console.log("🔍 Restarted refund flow from question 1");
    } catch (error) {
      console.error("🔍 Error restarting refund flow:", error);
      message.error("Failed to restart refund flow. Please try again.");
    }
  };
  const [answers, setAnswers] = useState({});
  const [currentQuestionId, setCurrentQuestionId] = useState(null);

  // When URL flow id changes (e.g. after "Continue" from suggestion modal), sync state so savings flow loads
  useEffect(() => {
    const urlFlowId = params.id;
    if (urlFlowId && urlFlowId !== activeFlowId) {
      setActiveFlowId(urlFlowId);
      setStep(1);
      setCurrentQuestionId(null);
      setAnswers({});
      setNextFlowId(null);
      setIsModalOpen(false);
      setIsModalSavinglOpen(false);
      setIsRefundModalOpen(false);
      setIsRefundAmountModalOpen(false);
      setIsSuggestionTaxSavingOpen(false);
    }
  }, [params.id]);

  useEffect(() => {
    // Reinitialize when questions are available and current question was reset.
    // This avoids getting stuck on "Loading questions..." when data is cached.
    if (questionsData && questionsData.length > 0) {
      const hasCurrentQuestion = questionsData.some(
        (q) => q._id === currentQuestionId
      );
      if (currentQuestionId && hasCurrentQuestion) {
        return;
      }
      setCurrentQuestionId(questionsData[0]._id);
      const initialAnswers = {};
      questionsData.forEach((q) => {
        initialAnswers[q._id] =
          q.isMultiSelection && !isSavingsIncomeSingleSelect(q) ? [] : "";
      });
      setAnswers(initialAnswers);
    }
  }, [questionsData, currentQuestionId, activeFlowId]);

  useEffect(() => {
    // Fade in animation when page loads
    setTimeout(() => setIsPageVisible(true), 50);
  }, []);

  const handleChange = (questionId, option) => {
    setAnswers((prev) => {
      const currentAnswer = prev[questionId] ?? [];
      const isInputLikeQuestion = ["input", "email", "price", "numeric", "counter"].includes(
        currentQuestion?.type
      );
      const treatAsSingle =
        isInputLikeQuestion ||
        isSavingsIncomeSingleSelect(currentQuestion) ||
        !(
          currentQuestion.type === "checkbox" ||
          currentQuestion.type === "grid_checkboxv2" ||
          currentQuestion.isMultiSelection
        );

      if (!treatAsSingle) {
        // Toggle option (add/remove)
        const arr = Array.isArray(currentAnswer) ? currentAnswer : [currentAnswer].filter(Boolean);
        if (arr.includes(option)) {
          return {
            ...prev,
            [questionId]: arr.filter((o) => o !== option),
          };
        } else {
          return {
            ...prev,
            [questionId]: [...arr, option],
          };
        }
      } else {
        // Radio: single value
        return {
          ...prev,
          [questionId]: option,
        };
      }
    });
  };

  const patchEstimation = async (estimationId, payload) => {
    const token = localStorage.getItem("extarrnalToken"); // your JWT
    try {
      const response = await axios.patch(
        `https://api.savyapp.dev/api/v1/estimations/${estimationId}`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (err) {
      console.error("Failed to update estimation:", err);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setIsModalSavinglOpen(false);
    setIsRefundModalOpen(false);
    setShowSavingsFlowButtonInRefundModal(false);
    setIsRefundAmountModalOpen(false);
    setIsAppInstallModalOpen(false);
    setIsSuggestionTaxSavingOpen(false);
  };

  const handleCloseAppInstallModal = () => {
    setIsAppInstallModalOpen(false);
    navigate(`/preview/flow/${REFUND_FLOW_ID}`, { replace: true });
  };

  const handleNext = async () => {
    setIsNextLoading(true);
    try {
    const currentQuestion = questionsData.find(
      (q) => q._id === currentQuestionId
    );
    if (!currentQuestion) return;

    const userAnswer = answers[currentQuestion._id];

    // For radiov2 with isMultiSelection, userAnswer is array of labels → build array of values
    let matchedInput;
    let computedValue;
    if (
      currentQuestion.type === "radiov2" &&
      currentQuestion.isMultiSelection &&
      !isSavingsIncomeSingleSelect(currentQuestion) &&
      Array.isArray(userAnswer)
    ) {
      computedValue = userAnswer.map((label) => {
        const inp = currentQuestion.xhrParams?.inputs?.find(
          (i) => i.label === label || i.value === label
        );
        return inp ? inp.value : label;
      });
    } else if (currentQuestion.type.startsWith("radio")) {
      matchedInput = currentQuestion.xhrParams?.inputs?.find(
        (i) => i.label === userAnswer
      );
      if (matchedInput?.value?.includes?.("parseFloat")) {
        computedValue = parseFloat(String(userAnswer).replace(/,/g, ""));
      } else if (matchedInput?.value?.includes?.("parseInt")) {
        computedValue = parseInt(String(userAnswer).replace(/,/g, ""), 10);
      } else {
        computedValue = matchedInput?.value;
      }
    } else {
      matchedInput = currentQuestion.xhrParams?.inputs?.[0];
      if (matchedInput?.value?.includes?.("parseFloat")) {
        computedValue = parseFloat(String(userAnswer).replace(/,/g, ""));
      } else if (matchedInput?.value?.includes?.("parseInt")) {
        computedValue = parseInt(String(userAnswer).replace(/,/g, ""), 10);
      } else {
        computedValue = matchedInput?.value;
      }
    }

    const answerValue = computedValue;

    const xhrPayload = {};
    const validationTarget = currentQuestion.xhrParams?.validation?.target; // e.g. "income"

    // 1️⃣ Store the main value based on validation target (single or array for isMultiSelection)
    if (matchedInput || (currentQuestion?.isMultiSelection && computedValue !== undefined)) {
      xhrPayload[validationTarget || "value"] = computedValue;
    }

    // 2️⃣ Check if this question has validation logic in handleNext
    const validationFromHandleNext = currentQuestion.handleNext?.find(
      (h) => h.action === "validation"
    );

    if (validationFromHandleNext?.validation) {
      // Save validation details into xhrPayload
      xhrPayload.validation = {
        type: validationFromHandleNext.validation.type || null,
        target: validationFromHandleNext.validation.target || null,
      };
    }

    // 3️⃣ Refund flow: any question with dynamicHandleNext uses PATCH-then-resolve. Otherwise use validation path.
    const isRefundFlow = activeFlowId === REFUND_FLOW_ID;
    const refundEstimationId = localStorage.getItem("refundEstimationId");
    const hasDynamicHandleNext = (currentQuestion.dynamicHandleNext?.length ?? 0) > 0;

    const shouldUseRefundBranch =
      isRefundFlow &&
      refundEstimationId &&
      (validationFromHandleNext || hasDynamicHandleNext);

    if (shouldUseRefundBranch) {
      // —— Refund flow: PATCH first, then resolve next step from API response ——
      try {
          let finalAnswer = userAnswer;
          if (currentQuestion?.xhrParams?.validation?.type === "boolean") {
            if (typeof userAnswer === "string") {
              finalAnswer = userAnswer.toLowerCase() === "true";
            } else {
              finalAnswer = Boolean(userAnswer);
            }
          }
          console.log("🔍 Submitting answer (refund):", {
            flowId: activeFlowId,
            ref: currentQuestion.ref,
            title: currentQuestion.title,
            value: finalAnswer,
            xhrParams: xhrPayload,
          });

          await createAnswer({
            flowId: activeFlowId,
            userId: localStorage.getItem("userId") || undefined,
            answers: [
              {
                ref: currentQuestion.ref,
                title: currentQuestion.title,
                value: finalAnswer,
              },
            ],
            xhrParams: xhrPayload,
            status: "in_progress",
          }).unwrap();

          let patchValue = computedValue;
          if (currentQuestion?.xhrParams?.validation?.type === "boolean") {
            let inputObj = currentQuestion?.xhrParams?.inputs?.find(
              (i) => i.label === userAnswer || i.value === userAnswer
            );
            let inputValue = inputObj?.value;
            patchValue =
              typeof inputValue === "string"
                ? inputValue.toLowerCase() === "true"
                : Boolean(inputValue);
          }
          if (currentQuestion?.xhrParams?.validation?.type === "listString") {
            const answersArray = Array.isArray(userAnswer)
              ? userAnswer
              : [userAnswer];
            patchValue = answersArray.map((ans) => {
              let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                (i) => i.label === ans || i.value === ans || i._id === ans
              );
              return inputObj ? inputObj.value : ans;
            });
          }
          if (currentQuestion?.xhrParams?.validation?.type === "list") {
            const answersArray = Array.isArray(userAnswer)
              ? userAnswer
              : [userAnswer];
            patchValue = answersArray
              .map((ans) => {
                let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                  (i) => i.label === ans || i.value === ans || i._id === ans
                );
                return inputObj ? parseInt(inputObj.value, 10) : null;
              })
              .filter((v) => v !== null);
          }

          const patchPayload = buildRefundEstimationPayload(
            currentQuestion,
            userAnswer,
            answers,
            validationTarget
          );

          const updated = await patchRefundEstimation(
            refundEstimationId,
            patchPayload
          );

          // Business rule: first refund question "Under £14k" is not eligible for refund.
          // Show the same "sorry / change my answers" modal immediately.
          const selectedAnswers = Array.isArray(userAnswer)
            ? userAnswer
            : [userAnswer];
          const isUnder14k =
            currentQuestion?.ref === "1" &&
            (
              (Array.isArray(patchPayload?.income) &&
                patchPayload.income.includes("under_14000")) ||
              selectedAnswers.some((ans) =>
                String(ans || "")
                  .toLowerCase()
                  .replace(/\s+/g, "")
                  .includes("under£14k")
              )
            );
          if (isUnder14k) {
            setShowSavingsFlowButtonInRefundModal(true);
            setIsRefundModalOpen(true);
            return;
          }

          setRefund(updated?.refund ?? refund);
          setRefundYears(updated?.refundYears ?? refundYears);
          setTotalExpenses(updated?.totalExpenses ?? totalExpenses);
          setAnnualSaving(updated?.annualSaving ?? annualSaving);
          if (updated?.refund != null) {
            setCompletedRefundAmount(updated.refund);
            lastRefundFromApiRef.current = updated.refund;
          }

          // Resolve dynamicHandleNext from refund estimation API response.
          // Use BOTH the API response (updated) AND the payload we just sent (patchPayload), so
          // conditions that depend on the current answer (e.g. travel_for_work_refund) match even
          // when the API does not echo those fields back.
          const conditionContextFromApi = {
            ...(typeof updated === "object" && updated !== null ? updated : {}),
            ...(typeof patchPayload === "object" && patchPayload !== null ? patchPayload : {}),
            annualSaving: updated?.annualSaving ?? annualSaving,
            refund: updated?.refund ?? refund,
            totalExpenses: updated?.totalExpenses ?? totalExpenses,
            // Aliases: backend conditions use snake_case; prefer API response, fallback to what we sent
            travel_for_work_refund: updated?.travelForWork ?? patchPayload?.travelForWork,
            income_refund: updated?.income ?? patchPayload?.income,
            howDoYouMakeYourWorkJourneysRefund: updated?.vehicleType ?? patchPayload?.vehicleType,
            workJourneyTypeRefund: updated?.workJourneyType ?? patchPayload?.workJourneyType,
            foodAndDrinkRefund: updated?.didEmployerPayForFoodAndDrink ?? patchPayload?.didEmployerPayForFoodAndDrink,
          };
          const dynNext = currentQuestion.dynamicHandleNext?.find((dyn) => {
            const { field, operator, target } = dyn.conditions || {};
            if (!operator || target === undefined) return false;
            let fieldValue = conditionContextFromApi[field] ?? answerValue;
            // Normalize boolean for string comparison (backend uses "true"/"false")
            if ((field === "travel_for_work_refund" || field === "foodAndDrinkRefund") && typeof fieldValue === "boolean") {
              fieldValue = fieldValue ? "true" : "false";
            }
            switch (operator) {
              case "==":
                return fieldValue == target;
              case "!=":
                return fieldValue != target;
              case ">":
                return Number(fieldValue) > Number(target);
              case "<":
                return Number(fieldValue) < Number(target);
              case ">=":
                return Number(fieldValue) >= Number(target);
              case "<=":
                return Number(fieldValue) <= Number(target);
              default:
                return false;
            }
          });

          if (!dynNext) {
            setShowSavingsFlowButtonInRefundModal(false);
            setIsRefundModalOpen(true);
            return;
          }

          if (dynNext.action === "navigate") {
            setNextFlowId(dynNext.nextQst);
            const isCongratsRefund =
              String(dynNext.nextQst || "").includes("Congrats") ||
              String(dynNext.nextQst || "").includes("congrats");
            if (isCongratsRefund || updated?.refund != null) {
              if (updated?.refund != null)
                setCompletedRefundAmount(updated.refund);
              setIsRefundAmountModalOpen(true);
            } else {
              setShowSavingsFlowButtonInRefundModal(false);
              setIsRefundModalOpen(true);
            }
          } else if (dynNext.action === "open_question") {
            const nextQuestion = questionsData.find(
              (q) => q.ref === dynNext.nextQst
            );
            if (nextQuestion) {
              setStep((prev) => prev + 1);
              setCurrentQuestionId(nextQuestion._id);
            } else {
              message.error("⚠️ Next question not found.");
            }
          }
        } catch (error) {
          console.error("Failed to submit answer:", error);
          message.error("Failed to submit answer. Please try again.");
        }
        return;
    }

    // —— Savings / other flows: resolve dynNext from current state, then submit ——
    if (validationFromHandleNext) {
      const conditionContext = { annualSaving };
      const dynNext = currentQuestion.dynamicHandleNext?.find((dyn) => {
        const { field, operator, target } = dyn.conditions || {};
        if (!operator || target === undefined) return false;
        const fieldValue = conditionContext[field] ?? answerValue;
        switch (operator) {
          case "==":
            return fieldValue == target;
          case "!=":
            return fieldValue != target;
          case ">":
            return Number(fieldValue) > Number(target);
          case "<":
            return Number(fieldValue) < Number(target);
          case ">=":
            return Number(fieldValue) >= Number(target);
          case "<=":
            return Number(fieldValue) <= Number(target);
          default:
            return false;
        }
      });

      if (!dynNext) {
        const currentFlowTitle = currentQuestion?.flow?.title;
        if (currentFlowTitle === "Refund") {
          setShowSavingsFlowButtonInRefundModal(false);
          setIsRefundModalOpen(true);
          return;
        } else {
          message.error("❗ No matching dynamic condition found.");
          return;
        }
      }

      // 5️⃣ Submit the answer to API (savings flow)
      try {
        let finalAnswer = userAnswer;
        if (currentQuestion?.xhrParams?.validation?.type === "boolean") {
          if (typeof userAnswer === "string") {
            finalAnswer = userAnswer.toLowerCase() === "true";
          } else {
            finalAnswer = Boolean(userAnswer);
          }
        }
        console.log("🔍 Submitting answer:", {
          flowId: activeFlowId,
          ref: currentQuestion.ref,
          title: currentQuestion.title,
          value: finalAnswer,
          xhrParams: xhrPayload,
          userAnswer: userAnswer,
        });

        await createAnswer({
          flowId: activeFlowId,
          userId: localStorage.getItem("userId") || undefined,
          answers: [
            {
              ref: currentQuestion.ref,
              title: currentQuestion.title,
              value: finalAnswer,
            },
          ],
          xhrParams: xhrPayload,
          status: "in_progress",
        }).unwrap();

        if (estimationId) {
          let patchValue = computedValue;
          if (
            currentQuestion.ref === "5" &&
            answers["689c6c7b64d03f7782f0a4e8"]
          ) {
            patchValue = parseFloat(answers["689c6c7b64d03f7782f0a4e8"]);
          }
          // 🔥 If validation says it's a boolean, cast properly
          if (currentQuestion?.xhrParams?.validation?.type === "boolean") {
            let inputObj = currentQuestion?.xhrParams?.inputs?.find(
              (i) => i.label === userAnswer || i.value === userAnswer
            );
            let inputValue = inputObj?.value;
            patchValue =
              typeof inputValue === "string"
                ? inputValue.toLowerCase() === "true"
                : Boolean(inputValue);
          }
          if (currentQuestion?.xhrParams?.validation?.type === "listString") {
            const answersArray = Array.isArray(userAnswer)
              ? userAnswer
              : [userAnswer];
            patchValue = answersArray.map((ans) => {
              let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                (i) => i.label === ans || i.value === ans || i._id === ans
              );
              return inputObj ? inputObj.value : ans;
            });
          }
          if (currentQuestion?.xhrParams?.validation?.type === "list") {
            const answersArray = Array.isArray(userAnswer)
              ? userAnswer
              : [userAnswer];
            patchValue = answersArray
              .map((ans) => {
                let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                  (i) => i.label === ans || i.value === ans || i._id === ans
                );
                return inputObj ? parseInt(inputObj.value, 10) : null;
              })
              .filter((v) => v !== null);
          }

          const isRefundFlowHere = activeFlowId === REFUND_FLOW_ID;
          const refundEstimationIdSavings = localStorage.getItem("refundEstimationId");

          if (isRefundFlowHere && refundEstimationIdSavings) {
            // Should not reach here often; use same payload builder as Refund branch
            const patchPayloadRefund = buildRefundEstimationPayload(
              currentQuestion,
              userAnswer,
              answers,
              validationTarget
            );
            const updated = await patchRefundEstimation(
              refundEstimationIdSavings,
              patchPayloadRefund
            );
            setRefund(updated?.refund ?? refund);
            setRefundYears(updated?.refundYears ?? refundYears);
            setTotalExpenses(updated?.totalExpenses ?? totalExpenses);
            setAnnualSaving(updated?.annualSaving ?? annualSaving);
            if (updated?.refund != null) {
              setCompletedRefundAmount(updated.refund);
              lastRefundFromApiRef.current = updated.refund;
            }
          } else if (!isRefundFlowHere) {
            if (validationTarget === "howDoYouMakeYourWorkJourneys") {
              patchValue = mapSavingsWorkJourneyValue(userAnswer);
            }
            let patchPayload = { [validationTarget]: patchValue };
            if (
              (currentQuestion?.ref === "5" &&
                currentQuestion?.flow?.title === "Refund") ||
              validationTarget === "refundYears" ||
              currentQuestion?.ref === "13"
            ) {
              if (Array.isArray(userAnswer)) {
                patchPayload.refundYears = userAnswer.length;
              } else if (typeof userAnswer === "string" && userAnswer) {
                patchPayload.refundYears = userAnswer.split(",").length;
              } else if (typeof userAnswer === "number") {
                patchPayload.refundYears = userAnswer;
              }
            }
            if (currentQuestion?.ref === "5" && currentQuestion?.flow?.title !== "Refund") {
              if (userAnswer === "No expenses") {
                patchPayload = { mileageType: 3, mileageRate: null };
              } else if (userAnswer === "Fuel card") {
                patchPayload = { mileageType: 2, mileageRate: 0 };
              } else {
                patchPayload = {
                  mileageType: 1,
                  mileageRate:
                    parseFloat(answers["689c6c7b64d03f7782f0a4e8"]) / 100,
                };
              }
            }
            if (currentQuestion?.type === "grid_checkboxv2") {
              const answersArray = Array.isArray(userAnswer)
                ? userAnswer
                : [userAnswer];
              patchValue = answersArray.map((ans) => {
                let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                  (i) => i.label === ans || i.value === ans || i._id === ans
                );
                return inputObj ? inputObj.value : ans;
              });
              patchPayload = {
                [validationTarget]: patchValue,
                selectedCount: patchValue.length,
              };
              if (
                currentQuestion?.ref === "5" &&
                currentQuestion?.flow?.title === "Refund"
              ) {
                patchPayload.refundYears = patchValue.length;
              }
            }
            const updatedEstimation = await patchEstimation(
              estimationId,
              patchPayload
            );
            setAnnualSaving(updatedEstimation.annualSaving || 0);
            setSpendPerDay(updatedEstimation.spendPerDay || 0);
            setRefund(updatedEstimation.refund || 0);
            setRefundYears(updatedEstimation.refundYears || 0);
          }
        }
      } catch (error) {
        console.error("Failed to submit answer:", error);
        message.error("Failed to submit answer. Please try again.");
        return;
      }

      if (dynNext.action === "navigate") {
        setNextFlowId(dynNext.nextQst);

        const currentFlowTitle = currentQuestion?.flow?.title;
        const isRefundNavigate =
          currentFlowTitle === "Refund" || activeFlowId === REFUND_FLOW_ID;
        const isCongratsRefund =
          String(dynNext.nextQst || "").includes("Congrats") ||
          String(dynNext.nextQst || "").includes("congrats");

        if (isRefundNavigate && (isCongratsRefund || refund != null)) {
          if (refund != null) setCompletedRefundAmount(refund);
          setIsRefundAmountModalOpen(true);
        } else if (currentFlowTitle === "Refund" && !isCongratsRefund) {
          setShowSavingsFlowButtonInRefundModal(false);
          setIsRefundModalOpen(true);
        } else {
          setIsModalOpen(true);
        }
      } else if (dynNext.action === "open_question") {
        const nextQuestion = questionsData.find(
          (q) => q.ref === dynNext.nextQst
        );
        if (nextQuestion) {
          setStep((prev) => prev + 1); // ✅ Increment here too

          setCurrentQuestionId(nextQuestion._id);
        } else {
          message.error("⚠️ Next question not found.");
        }
      }
      return;
    }

    // If no validation/dynamicHandleNext, fallback to original next handling
    const nextHandle = currentQuestion.handleNext?.[0];
    let nextQuestion = null;

    if (nextHandle?.action === "open_question") {
      nextQuestion = questionsData.find((q) => q.ref === nextHandle.nextQst);
    }
    if (matchedInput?.value === "1") xhrPayload.status = "Completed";
    if (matchedInput?.value === "2" || matchedInput?.value === "3")
      xhrPayload.status = "In progress";

    const isLastQuestion = !nextQuestion;

    const answerPayload = {
      flowId: activeFlowId,
      userId: localStorage.getItem("userId") || undefined,
      answers: [
        {
          ref: currentQuestion.ref,
          title: currentQuestion.title,
          value: userAnswer,
        },
      ],
      xhrParams: xhrPayload,
      status: isLastQuestion ? "completed" : "in_progress",
    };

    try {
      console.log("🔍 Submitting fallback answer:", answerPayload);
      await createAnswer(answerPayload).unwrap();
      if (estimationId) {
        let patchValue = computedValue;
        if (
          currentQuestion.ref === "5" &&
          answers["689c6c7b64d03f7782f0a4e8"]
        ) {
          patchValue = parseFloat(answers["689c6c7b64d03f7782f0a4e8"]);
        }
        // 🔥 If validation says it's a boolean, cast properly
        if (currentQuestion?.xhrParams?.validation?.type === "boolean") {
          let inputObj = currentQuestion?.xhrParams?.inputs?.find(
            (i) => i.label === userAnswer || i.value === userAnswer
          );

          let inputValue = inputObj?.value;

          // Update the outer patchValue
          patchValue =
            typeof inputValue === "string"
              ? inputValue.toLowerCase() === "true"
              : Boolean(inputValue);
        }

        if (currentQuestion?.xhrParams?.validation?.type === "listString") {
          // Normalize to array in case user selected only one answer
          const answersArray = Array.isArray(userAnswer)
            ? userAnswer
            : [userAnswer];

          // Map user selections to the "value" field
          patchValue = answersArray.map((ans) => {
            let inputObj = currentQuestion?.xhrParams?.inputs?.find(
              (i) => i.label === ans || i.value === ans || i._id === ans
            );
            return inputObj ? inputObj.value : ans; // must be value, not label
          });
        }

        if (currentQuestion?.xhrParams?.validation?.type === "list") {
          // Normalize to array in case user selected only one answer
          const answersArray = Array.isArray(userAnswer)
            ? userAnswer
            : [userAnswer];

          // Map labels/values back to the integer values from inputs
          patchValue = answersArray
            .map((ans) => {
              let inputObj = currentQuestion?.xhrParams?.inputs?.find(
                (i) => i.label === ans || i.value === ans || i._id === ans
              );
              return inputObj ? parseInt(inputObj.value, 10) : null; // cast to int
            })
            .filter((v) => v !== null); // remove nulls if no match
        }

        let patchPayload = {
          [validationTarget]: patchValue,
        };

        if (
          activeFlowId !== REFUND_FLOW_ID &&
          validationTarget === "howDoYouMakeYourWorkJourneys"
        ) {
          patchPayload[validationTarget] = mapSavingsWorkJourneyValue(userAnswer);
        }

        // Special handling for refund years - check for ref "5" in refund flow
        if (
          (currentQuestion?.ref === "5" &&
            currentQuestion?.flow?.title === "Refund") ||
          currentQuestion?.ref === "13" ||
          validationTarget === "refundYears"
        ) {
          // This is the year selection question
          if (Array.isArray(userAnswer)) {
            patchPayload.refundYears = userAnswer.length;
          } else if (typeof userAnswer === "string" && userAnswer) {
            // Count commas + 1 to get number of selected years
            patchPayload.refundYears = userAnswer.split(",").length;
          } else if (typeof userAnswer === "number") {
            // Direct number value
            patchPayload.refundYears = userAnswer;
          }
          console.log(
            "🔍 Setting refundYears (fallback - ref 5 refund):",
            patchPayload.refundYears
          );
          console.log("🔍 User answer (fallback):", userAnswer);
          console.log("🔍 Question ref (fallback):", currentQuestion?.ref);
          console.log(
            "🔍 Flow title (fallback):",
            currentQuestion?.flow?.title
          );
        }

        if (currentQuestion?.ref === "5") {
          // Example: map user answer into { mileageType, mileageRate }
          if (userAnswer === "No expenses") {
            patchPayload = { mileageType: 3, mileageRate: null };
          } else if (userAnswer === "Fuel card") {
            patchPayload = { mileageType: 2, mileageRate: 0 };
          } else {
            // Default: use API response values
            patchPayload = {
              mileageType: 1,
              mileageRate:
                parseFloat(answers["689c6c7b64d03f7782f0a4e8"]) / 100,
            };
          }
        }

        // Handle grid_checkboxv2 in fallback section
        if (currentQuestion?.type === "grid_checkboxv2") {
          // Ensure array
          const answersArray = Array.isArray(userAnswer)
            ? userAnswer
            : [userAnswer];

          // Map to actual "value" from inputs if needed
          patchValue = answersArray.map((ans) => {
            let inputObj = currentQuestion?.xhrParams?.inputs?.find(
              (i) => i.label === ans || i.value === ans || i._id === ans
            );
            return inputObj ? inputObj.value : ans;
          });

          // ✅ Add length of selected choices
          patchPayload = {
            [validationTarget]: patchValue,
            selectedCount: patchValue.length, // <-- here's the count
          };

          // Special case: if this is the refund years question, set refundYears
          if (
            currentQuestion?.ref === "5" &&
            currentQuestion?.flow?.title === "Refund"
          ) {
            patchPayload.refundYears = patchValue.length;
            console.log(
              "🔍 Setting refundYears from grid_checkboxv2 (fallback):",
              patchValue.length
            );
            console.log("🔍 Selected years (fallback):", patchValue);
          }
        }

        const refundEstimationIdFallback = localStorage.getItem("refundEstimationId");
        const isRefundFlowFallback = activeFlowId === REFUND_FLOW_ID;

        if (isRefundFlowFallback && refundEstimationIdFallback) {
          const refundPatch = buildRefundEstimationPayload(
            currentQuestion,
            userAnswer,
            answers,
            validationTarget
          );
          if (isLastQuestion) refundPatch.status = "completed";
          const updatedRefund = await patchRefundEstimation(
            refundEstimationIdFallback,
            refundPatch
          );
          setRefund(updatedRefund?.refund ?? refund);
          setRefundYears(updatedRefund?.refundYears ?? refundYears);
          setTotalExpenses(updatedRefund?.totalExpenses ?? totalExpenses);
          setAnnualSaving(updatedRefund?.annualSaving ?? annualSaving);
          if (updatedRefund?.refund != null) {
            setCompletedRefundAmount(updatedRefund.refund);
            lastRefundFromApiRef.current = updatedRefund.refund;
          }
        } else if (!isRefundFlowFallback) {
          const updatedEstimation = await patchEstimation(
            estimationId,
            patchPayload
          );
          setAnnualSaving(updatedEstimation.annualSaving || 0);
          setSpendPerDay(updatedEstimation.spendPerDay || 0);
          setRefund(updatedEstimation.refund || 0);
          setRefundYears(updatedEstimation.refundYears || 0);
        }
      }
      if (nextQuestion) {
        setStep((prev) => prev + 1); // ✅ Increment here too

        setCurrentQuestionId(nextQuestion._id);
      } else {
        // Check if current flow is "Refund" and show appropriate modal
        const currentFlowTitle = currentQuestion?.flow?.title;
        if (currentFlowTitle === "Refund") {
          setIsRefundAmountModalOpen(true);
        } else {
          setIsModalSavinglOpen(true);
        }
        setNextFlowId(nextHandle?.nextQst); // save the target flowId
      }
    } catch (error) {
      console.error("Failed to submit answer:", error);
      message.error("Failed to submit answer. Please try again.", error);
    }
    } finally {
      setIsNextLoading(false);
    }
  };

  if (isLoading || !currentQuestionId) {
    return (
      <div className="flex justify-center items-center h-screen">
        Loading questions...
      </div>
    );
  }
  const currentQuestion = questionsData.find(
    (q) => q._id === currentQuestionId
  );
  if (!isLoading && questionsData?.length > 0 && !currentQuestion) {
    setCurrentQuestionId(questionsData[0]._id);
    return (
      <div className="flex justify-center items-center h-screen">
        Loading questions...
      </div>
    );
  }

  const progressValues = questionsData.map((q) => q.progress);
  const totalSteps = Math.max(...progressValues) + 1;
  const stepIndex = currentQuestion?.progress ?? 0;
  const progressPercent = ((stepIndex + 1) / totalSteps) * 100;

  const getShortInputLabel = (q) => {
    if (!q) return "";
    const t = (q.title || q.name || "").toLowerCase();
    const ref = String(q.ref || "");
    if (ref === "5" || t.includes("miles") || t.includes("mile")) return "Miles per year";
    if (t.includes("spend") || t.includes("food") || t.includes("drink")) return "Weekly spend";
    if (t.includes("rate") && !t.includes("mile")) return "Rate";
    const full = (q.title || q.name || "").trim();
    if (full.length <= 22) return full;
    const words = full.split(/\s+/).slice(0, 3).join(" ");
    return words.length > 22 ? words.slice(0, 19) + "…" : words;
  };

  const getInputPlaceholder = (q) => {
    const fromQuestion = q?.placeholder || q?.xhrParams?.placeholder;
    if (fromQuestion) return fromQuestion;
    const title = String(q?.title || "").toLowerCase();
    const ref = String(q?.ref || "");

    if (ref === "5" || title.includes("miles") || title.includes("mile")) {
      return "Ex - 8,000";
    }

    switch (q?.type) {
      case "price":
        return "Ex - £10.5";
      case "numeric":
      case "counter":
        return "Ex - 10";
      case "email":
        return "Ex - name@email.com";
      default:
        return "Type your answer";
    }
  };

  const getInputLimits = (q) => {
    const title = String(q?.title || "").toLowerCase();
    const ref = String(q?.ref || "");

    // Miles per year
    if (ref === "5" || title.includes("miles") || title.includes("mile")) {
      return { maxLength: 7, min: 0, max: 200000, step: "1" };
    }

    // Weekly spend / day spend / price-like fields
    if (
      q?.type === "price" ||
      title.includes("spend") ||
      title.includes("cost")
    ) {
      return { maxLength: 8, min: 0, max: 10000, step: "0.01" };
    }

    // Generic numeric / counter fields
    if (q?.type === "numeric" || q?.type === "counter") {
      return { maxLength: 6, min: 0, max: 100000, step: "1" };
    }

    if (q?.type === "email") {
      return { maxLength: 120 };
    }

    return { maxLength: 100 };
  };

  const isMilesQuestion = (q) => {
    const title = String(q?.title || "").toLowerCase();
    const ref = String(q?.ref || "");
    return ref === "5" || title.includes("miles") || title.includes("mile");
  };

  const isDaysPerWeekQuestion = (q) => {
    const title = String(q?.title || "").toLowerCase();
    return (
      title.includes("how many days do you travel a week") ||
      title.includes("days do you travel a week")
    );
  };

  const mapSavingsWorkJourneyValue = (value) => {
    const raw = Array.isArray(value) ? value[0] : value;
    const normalized = String(raw || "")
      .toLowerCase()
      .replace(/\n/g, " ")
      .replace(/\s+/g, " ")
      .trim();

    if (
      normalized === "my_vehicle" ||
      normalized === "company_vehicle" ||
      normalized === "train"
    ) {
      return normalized;
    }
    if (normalized.includes("my vehicle")) return "my_vehicle";
    if (normalized.includes("company vehicle")) return "company_vehicle";
    if (normalized.includes("train")) return "train";
    return raw;
  };

  return (
    <>
      <div
        className={`h-full flex flex-col w-full transition-all duration-500 ease-out ${
          isPageVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-4"
        }`}
        style={{
          paddingTop: "env(safe-area-inset-top)",
          paddingBottom: "calc(env(safe-area-inset-bottom) + 20px)",
        }}
      >
        {/* Main Content Area */}
        <div className="flex-1 flex flex-col max-w-3xl mx-auto w-full px-4 sm:px-6 md:px-8 py-2 sm:py-3 md:py-4 min-h-0 overflow-hidden">
          {currentQuestion && (
            <div className="bg-white shadow-xl rounded-xl flex flex-col h-full min-h-0 overflow-hidden">
              {/* Progress Bar at Top of Card */}
              <div className="w-full h-1 sm:h-1.5 bg-gray-100 rounded-t-xl overflow-hidden">
                <div
                  className="h-full bg-gradient-to-r from-[#8AB9F1] via-[#b57edc] to-[#F08080] transition-all duration-700 ease-out shadow-sm"
                  style={{ width: `${progressPercent}%` }}
                >
                  <div className="h-full w-full bg-gradient-to-r from-transparent via-white/20 to-transparent animate-pulse"></div>
                </div>
              </div>

              {/* Top Bar - Back, Title, Step */}
              <div className="flex justify-between items-center px-4 sm:px-6 md:px-10 pt-3 sm:pt-4 md:pt-5 pb-2 gap-2">
                {/* Back Button */}
                <button
                  className="text-xs sm:text-sm text-blue-500 hover:text-blue-600 hover:underline disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap font-medium transition-colors"
                  onClick={() => {
                    console.log("Back button clicked");
                    console.log("Current question ID:", currentQuestionId);
                    console.log("Questions data:", questionsData);

                    const current = questionsData.find(
                      (q) => q._id === currentQuestionId
                    );
                    console.log("Current question:", current);

                    if (!current) {
                      console.log("No current question found");
                      return;
                    }

                    // Get all progress values and sort them
                    const allProgressValues = questionsData
                      .map((q) => q.progress)
                      .sort((a, b) => a - b);

                    console.log("All progress values:", allProgressValues);
                    console.log("Current progress:", current.progress);

                    // Find the previous progress value that's less than current
                    const currentProgressIndex = allProgressValues.indexOf(
                      current.progress
                    );
                    const previousProgressValue =
                      currentProgressIndex > 0
                        ? allProgressValues[currentProgressIndex - 1]
                        : null;

                    console.log(
                      "Previous progress value:",
                      previousProgressValue
                    );

                    if (previousProgressValue !== null) {
                      const previousQuestion = questionsData.find(
                        (q) => q.progress === previousProgressValue
                      );
                      console.log("Previous question found:", previousQuestion);

                      if (previousQuestion) {
                        setStep((prev) => prev - 1);
                        setCurrentQuestionId(previousQuestion._id);
                        console.log(
                          "Navigated to previous question:",
                          previousQuestion._id
                        );
                      } else {
                        console.log(
                          "No previous question found with progress:",
                          previousProgressValue
                        );
                      }
                    } else {
                      console.log(
                        "No previous progress value found - already at first question"
                      );
                    }
                  }}
                  disabled={
                    !currentQuestion ||
                    (questionsData &&
                      questionsData.length > 0 &&
                      questionsData
                        .map((q) => q.progress)
                        .sort((a, b) => a - b)[0] === currentQuestion.progress)
                  }
                >
                  &larr; Back
                </button>

                {/* Title */}
                <h2 className="text-sm sm:text-base md:text-lg font-semibold text-center flex-1 px-2 text-gray-900">
                  Savings calculator
                </h2>

                {/* Step */}
                <span className="text-xs sm:text-sm text-gray-600 text-right whitespace-nowrap font-medium">
                  Step {step}
                </span>
              </div>

              {/* Question Content - Scrollable */}
              <div className="flex-1 flex flex-col min-h-0 overflow-y-auto px-4 sm:px-6 md:px-10 py-2 sm:py-3">
                {/* Question Content */}
                <div className="flex-1 flex flex-col justify-center">
                  <h3 className="text-base sm:text-lg md:text-xl font-normal mb-3 sm:mb-4 leading-relaxed">
                    {currentQuestion.ref === "12"
                      ? currentQuestion.title.replace(
                          /\$\{data\?.spendPerDay\}/g,
                          spendPerDay || "0"
                        )
                      : currentQuestion.title}
                  </h3>

                  {(currentQuestion.type === "radio" ||
                    currentQuestion.type === "checkbox") && (
                    <div className="space-y-2 sm:space-y-3">
                      {currentQuestion.options.map((option) => {
                        const isSelected = answers[currentQuestion._id] === option;
                        const optionText = String(option || "").toLowerCase();
                        const isRateOption =
                          optionText.includes("rate") &&
                          !optionText.includes("fuel") &&
                          !optionText.includes("no expenses");
                        const proposalInputs =
                          currentQuestion?.proposal?.[option] ||
                          currentQuestion?.xhrParams?.proposal?.[option] ||
                          currentQuestion?.proposal?.["Mileage rate"] ||
                          currentQuestion?.xhrParams?.proposal?.["Mileage rate"];
                        const firstInput = Array.isArray(proposalInputs)
                          ? proposalInputs[0]
                          : null;
                        const inputId =
                          firstInput?._id ||
                          firstInput?.ref ||
                          "689c6c7b64d03f7782f0a4e8";
                        const rawLabel = firstInput?.label || "Rate";
                        const mileageLabel =
                          rawLabel.length > 15 ? "Rate" : rawLabel;

                        return (
                          <div key={option} className="flex flex-col gap-2">
                            <label className="flex items-center p-2 sm:p-3 rounded-lg cursor-pointer space-x-2 sm:space-x-3 hover:bg-gray-50 transition-colors">
                              <input
                                type={currentQuestion.type}
                                className="hidden peer"
                                value={option}
                                checked={isSelected}
                                onChange={() =>
                                  handleChange(currentQuestion._id, option)
                                }
                              />
                              {/* Outer Circle becomes black when selected */}
                              <div className="w-4 h-4 sm:w-5 sm:h-5 border-2 rounded-full peer-checked:bg-black border-gray-400 transition-colors duration-200 flex-shrink-0"></div>
                              <span className="text-sm sm:text-base">{option}</span>
                            </label>

                            {currentQuestion.type === "radio" &&
                              isSelected &&
                              isRateOption && (
                                <div className="relative w-full mt-2">
                                  <div className="relative">
                                    <div className="flex items-center w-full border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition">
                                      <input
                                        type="number"
                                        id={`input-${inputId}`}
                                        placeholder={firstInput?.placeholder || "Ex - 10.5"}
                                        inputMode="decimal"
                                        pattern="[0-9]*[.,]?[0-9]*"
                                        min="0"
                                        max="100"
                                        step="0.1"
                                        className="peer flex-1 bg-white pl-4 sm:pl-6 py-3 sm:py-3.5 text-gray-900 rounded-md focus:outline-none text-base leading-normal"
                                        value={answers[inputId] ?? ""}
                                        onChange={(e) => {
                                          const sanitized = String(e.target.value)
                                            .replace(/,/g, ".")
                                            .replace(/[^0-9.]/g, "")
                                            .replace(/(\..*)\./g, "$1")
                                            .slice(0, 6);
                                          handleChange(inputId, sanitized);
                                        }}
                                        onBlur={(e) => {
                                          const n = Number(e.target.value);
                                          if (!Number.isFinite(n)) return;
                                          const clamped = Math.min(100, Math.max(0, n));
                                          handleChange(inputId, String(clamped));
                                        }}
                                      />
                                    </div>
                                    <label
                                      htmlFor={`input-${inputId}`}
                                      className="absolute left-3 sm:left-4 -top-2.5 bg-white px-1 text-gray-500 text-xs sm:text-sm pointer-events-none"
                                    >
                                      {mileageLabel}
                                    </label>
                                  </div>
                                </div>
                              )}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {(currentQuestion.type === "radiov2" ||
                    currentQuestion.type === "grid_checkboxv2") && (
                    <div
                      className={`grid gap-3 sm:gap-4 ${
                        currentQuestion.options.length === 2
                          ? "grid-cols-2"
                          : "grid-cols-1 sm:grid-cols-2 md:grid-cols-3"
                      }`}
                    >
                      {currentQuestion.options.map((option) => {
                        const isMulti =
                          !isSavingsIncomeSingleSelect(currentQuestion) &&
                          (currentQuestion.type === "grid_checkboxv2" ||
                            currentQuestion.isMultiSelection);
                        const isSelected = isMulti
                          ? answers[currentQuestion._id]?.includes(option)
                          : answers[currentQuestion._id] === option;
                        return (
                          <div
                            key={option}
                            className="flex flex-col gap-2"
                          >
                            {/* Radio Option */}
                            <div
                              onClick={() =>
                                handleChange(currentQuestion._id, option)
                              }
                              className={`relative cursor-pointer rounded-xl overflow-hidden transition ${
                                isSelected ? "" : "border border-gray-300"
                              }`}
                            >
                              {isSelected && (
                                <div className="absolute inset-0 custom-gradient" />
                              )}
                              <div
                                className={`relative z-10 rounded-xl py-3 sm:py-4 text-center bg-white text-black text-sm sm:text-base`}
                                style={{
                                  border: isSelected
                                    ? "2px solid transparent"
                                    : "",
                                  backgroundClip: isSelected
                                    ? "padding-box"
                                    : "",
                                }}
                              >
                                {option}
                              </div>
                            </div>

                            {/* Extra Numeric Input for mileage-rate style options */}
                            {isSelected && (() => {
                              const optionText = String(option || "").toLowerCase();
                              const isRateOption =
                                optionText.includes("rate") &&
                                !optionText.includes("fuel") &&
                                !optionText.includes("no expenses");
                              if (!isRateOption) return null;

                              const proposalInputs =
                                currentQuestion?.proposal?.[option] ||
                                currentQuestion?.xhrParams?.proposal?.[option] ||
                                currentQuestion?.proposal?.["Mileage rate"] ||
                                currentQuestion?.xhrParams?.proposal?.["Mileage rate"];
                              const firstInput = Array.isArray(proposalInputs) ? proposalInputs[0] : null;
                              const inputId = firstInput?._id || firstInput?.ref || "689c6c7b64d03f7782f0a4e8";
                              const rawLabel = firstInput?.label || "Rate";
                              const mileageLabel = rawLabel.length > 15 ? "Rate" : rawLabel;
                              return (
                              <div className="relative w-full mt-4 sm:mt-6">
                                <div className="relative">
                                  <div className="flex items-center w-full border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition">
                                    <input
                                      type="number"
                                      id={`input-${inputId}`}
                                      placeholder={firstInput?.placeholder || "Ex - 10.5"}
                                      inputMode="decimal"
                                      pattern="[0-9]*[.,]?[0-9]*"
                                      min="0"
                                      max="100"
                                      step="0.1"
                                      className="peer flex-1 bg-white pl-4 sm:pl-6 py-3 sm:py-3.5 text-gray-900 rounded-md focus:outline-none text-base leading-normal"
                                      value={
                                        answers[inputId] ?? ""
                                      }
                                      onChange={(e) => {
                                        const sanitized = String(e.target.value)
                                          .replace(/,/g, ".")
                                          .replace(/[^0-9.]/g, "")
                                          .replace(/(\..*)\./g, "$1")
                                          .slice(0, 6);
                                        handleChange(inputId, sanitized);
                                      }}
                                      onBlur={(e) => {
                                        const n = Number(e.target.value);
                                        if (!Number.isFinite(n)) return;
                                        const clamped = Math.min(100, Math.max(0, n));
                                        handleChange(inputId, String(clamped));
                                      }}
                                    />
                                  </div>
                                  <label
                                    htmlFor={`input-${inputId}`}
                                    className="absolute left-3 sm:left-4 -top-2.5 bg-white px-1 text-gray-500 text-xs sm:text-sm pointer-events-none"
                                  >
                                    {mileageLabel}
                                  </label>
                                </div>
                              </div>
                              );
                            })()}
                          </div>
                        );
                      })}
                    </div>
                  )}

                  {["input", "email", "price", "numeric", "counter"].includes(
                    currentQuestion.type
                  ) && (
                    <div className="relative w-full mt-4 sm:mt-6">
                      <div className="relative">
                        {/* Wrapper with flex if price */}
                        <div
                          className={`flex items-center w-full border border-gray-300 rounded-md focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-transparent transition ${
                            currentQuestion.type === "price" ? "" : "block"
                          }`}
                        >
                          {/* Price Prefix if type is 'price' */}
                          {currentQuestion.type === "price" && (
                            <span className="pl-3 sm:pl-4 py-3 sm:py-3.5 text-gray-700 text-sm sm:text-base self-center">
                              £
                            </span>
                          )}

                          <input
                            type={
                              currentQuestion.type === "email"
                                ? "email"
                                : "text"
                            }
                            id={`input-${currentQuestion._id}`}
                            placeholder={getInputPlaceholder(currentQuestion)}
                            inputMode={
                              isMilesQuestion(currentQuestion)
                                ? "numeric"
                                : ["price", "numeric", "counter"].includes(
                                currentQuestion.type
                              )
                                ? "decimal"
                                : undefined
                            }
                            pattern={
                              ["price", "numeric", "counter"].includes(
                                currentQuestion.type
                              )
                                ? "[0-9]*[.,]?[0-9]*"
                                : undefined
                            }
                            className={`peer flex-1 bg-white ${
                              currentQuestion.type === "price"
                                ? "pl-2"
                                : "pl-3 sm:pl-4"
                            } py-3 sm:py-3.5 text-gray-900 rounded-md focus:outline-none text-base leading-normal`}
                            value={answers[currentQuestion._id]}
                            maxLength={getInputLimits(currentQuestion).maxLength}
                            min={
                              ["price", "numeric", "counter"].includes(currentQuestion.type)
                                ? getInputLimits(currentQuestion).min
                                : undefined
                            }
                            max={
                              ["price", "numeric", "counter"].includes(currentQuestion.type)
                                ? (isDaysPerWeekQuestion(currentQuestion)
                                    ? 7
                                    : getInputLimits(currentQuestion).max)
                                : undefined
                            }
                            step={
                              ["price", "numeric", "counter"].includes(currentQuestion.type)
                                ? getInputLimits(currentQuestion).step
                                : undefined
                            }
                            onChange={(e) => {
                              const isNumericField = ["price", "numeric", "counter"].includes(
                                currentQuestion.type
                              );
                              const isMiles = isMilesQuestion(currentQuestion);
                              const isDaysPerWeek = isDaysPerWeekQuestion(currentQuestion);
                              if (!isNumericField) {
                                const nextVal = String(e.target.value).slice(
                                  0,
                                  getInputLimits(currentQuestion).maxLength
                                );
                                handleChange(
                                  currentQuestion._id,
                                  nextVal
                                );
                                if (isDaysPerWeek) {
                                  const n = Number(nextVal);
                                  if (nextVal !== "" && Number.isFinite(n) && n > 7) {
                                    setInputErrors((prev) => ({
                                      ...prev,
                                      [currentQuestion._id]: "The maximum number of days is 7",
                                    }));
                                  } else {
                                    setInputErrors((prev) => ({ ...prev, [currentQuestion._id]: "" }));
                                  }
                                }
                                return;
                              }
                              if (isMiles) {
                                const nextVal = String(e.target.value).slice(
                                  0,
                                  getInputLimits(currentQuestion).maxLength
                                );
                                handleChange(
                                  currentQuestion._id,
                                  nextVal
                                );
                                if (isDaysPerWeek) {
                                  const n = Number(nextVal);
                                  if (nextVal !== "" && Number.isFinite(n) && n > 7) {
                                    setInputErrors((prev) => ({
                                      ...prev,
                                      [currentQuestion._id]: "The maximum number of days is 7",
                                    }));
                                  } else {
                                    setInputErrors((prev) => ({ ...prev, [currentQuestion._id]: "" }));
                                  }
                                }
                                return;
                              }
                              const sanitized = String(e.target.value)
                                    .replace(/,/g, ".")
                                    .replace(/[^0-9.]/g, "")
                                    .replace(/(\..*)\./g, "$1")
                                    .slice(0, getInputLimits(currentQuestion).maxLength);
                              handleChange(currentQuestion._id, sanitized);
                              if (isDaysPerWeek) {
                                const n = Number(sanitized);
                                if (sanitized !== "" && Number.isFinite(n) && n > 7) {
                                  setInputErrors((prev) => ({
                                    ...prev,
                                    [currentQuestion._id]: "The maximum number of days is 7",
                                  }));
                                } else {
                                  setInputErrors((prev) => ({ ...prev, [currentQuestion._id]: "" }));
                                }
                              }
                            }}
                            onBlur={(e) => {
                              const isNumericField = ["price", "numeric", "counter"].includes(
                                currentQuestion.type
                              );
                              if (!isNumericField) return;
                              if (isMilesQuestion(currentQuestion)) return;
                              const raw = isMilesQuestion(currentQuestion)
                                ? String(e.target.value).replace(/,/g, "")
                                : e.target.value;
                              const n = Number(raw);
                              if (!Number.isFinite(n)) return;
                              const cfg = getInputLimits(currentQuestion);
                              const clamped = Math.min(cfg.max, Math.max(cfg.min, n));
                              handleChange(currentQuestion._id, String(clamped));
                            }}
                          />
                        </div>

                        {inputErrors[currentQuestion._id] && (
                          <p className="mt-2 text-xs sm:text-sm text-red-500">
                            {inputErrors[currentQuestion._id]}
                          </p>
                        )}

                        {/* Floating Label */}
                        <label
                          htmlFor={`input-${currentQuestion._id}`}
                          className="absolute left-3 sm:left-4 -top-2.5 bg-white px-1 text-gray-500 text-xs sm:text-sm pointer-events-none"
                        >
                          {getShortInputLabel(currentQuestion)}
                        </label>

                        {/* Character Counter */}
                      </div>
                    </div>
                  )}

                  {/* Info Banner */}
                  {currentQuestion.info && (
                    <div
                      className="mt-4 sm:mt-6 bg-[#edf3fd] text-sm text-gray-700 rounded-lg p-3 sm:p-4 flex items-start space-x-2 sm:space-x-3 border-l border-blue-300"
                      style={{ borderLeftWidth: "12px" }}
                    >
                      <img
                        src={InformationCircleIcon}
                        alt="info icon"
                        className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 mt-0.5"
                      />
                      <div className="flex-1">
                        <strong className="block mb-1 sm:mb-2 text-gray-900 font-medium text-sm sm:text-base">
                          {currentQuestion.infoTitle}
                        </strong>
                        <span className="text-xs sm:text-sm text-gray-600 leading-relaxed">
                          {currentQuestion.info}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* Button Inside Card Footer */}
              <div
                className="px-4 sm:px-6 md:px-10 pt-3 sm:pt-4 md:pt-5 pb-3 sm:pb-4 border-t border-gray-100 flex-shrink-0"
                style={{
                  paddingBottom: "calc(env(safe-area-inset-bottom) + 16px)",
                }}
              >
                <button
                  className="bg-[#002147] text-white py-3 sm:py-3.5 md:py-4 px-6 sm:px-12 md:px-16 lg:px-24 rounded-lg font-semibold hover:bg-[#003366] transition-all duration-200 block mx-auto w-full sm:w-auto min-w-[200px] sm:min-w-[280px] shadow-lg hover:shadow-xl transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden disabled:bg-gray-400 disabled:cursor-not-allowed disabled:hover:scale-100 disabled:hover:shadow-lg disabled:hover:bg-gray-400"
                  onClick={(e) => {
                    const ans = answers[currentQuestion?._id];
                    const isInputLikeQuestion = ["input", "email", "price", "numeric", "counter"].includes(
                      currentQuestion?.type
                    );
                    const isSingleSavingsIncome =
                      isSavingsIncomeSingleSelect(currentQuestion);
                    const hasInputError = Boolean(inputErrors[currentQuestion?._id]);
                    const hasAnswer =
                      (!isInputLikeQuestion &&
                      ((currentQuestion?.isMultiSelection &&
                        !isSingleSavingsIncome) ||
                      currentQuestion?.type === "checkbox" ||
                      currentQuestion?.type === "grid_checkboxv2"))
                        ? Array.isArray(ans) && ans.length > 0
                        : ans != null && ans !== "";
                    if (!hasAnswer || hasInputError) return;

                    // Add ripple effect
                    const button = e.currentTarget;
                    const ripple = document.createElement("span");
                    const rect = button.getBoundingClientRect();
                    const size = Math.max(rect.width, rect.height);
                    const x = e.clientX - rect.left - size / 2;
                    const y = e.clientY - rect.top - size / 2;

                    ripple.style.width = ripple.style.height = `${size}px`;
                    ripple.style.left = `${x}px`;
                    ripple.style.top = `${y}px`;
                    ripple.classList.add("ripple");

                    button.appendChild(ripple);
                    setTimeout(() => ripple.remove(), 600);

                    handleNext();
                  }}
                  disabled={
                    (() => {
                      const ans = answers[currentQuestion?._id];
                      const isInputLikeQuestion = ["input", "email", "price", "numeric", "counter"].includes(
                        currentQuestion?.type
                      );
                      const isSingleSavingsIncome =
                        isSavingsIncomeSingleSelect(currentQuestion);
                      const hasInputError = Boolean(inputErrors[currentQuestion?._id]);
                      const isMulti =
                        (!isInputLikeQuestion &&
                        ((currentQuestion?.isMultiSelection &&
                          !isSingleSavingsIncome) ||
                        currentQuestion?.type === "checkbox" ||
                        currentQuestion?.type === "grid_checkboxv2"));
                      const noAnswer = isMulti
                        ? !Array.isArray(ans) || ans.length === 0
                        : ans == null || ans === "";
                      return noAnswer || hasInputError || isSubmitting || isNextLoading;
                    })()
                  }
                >
                  {isSubmitting || isNextLoading ? (
                    <span className="inline-flex items-center gap-2 relative z-10">
                      <span className="inline-block w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      Calculating...
                    </span>
                  ) : (
                    <span className="relative z-10">Next →</span>
                  )}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Modals */}
      <CustomAlertModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onNavigate={handleNavigateFlow}
      />

      <SavingsModal
        isOpen={isModalSavinglOpen}
        onClose={closeModal}
        amount={annualSaving}
        onNavigate={() => {
          setIsModalSavinglOpen(false);
          setTimeout(() => setIsAppInstallModalOpen(true), 300);
        }}
      />

      <RefundModal
        isOpen={isRefundModalOpen}
        onClose={closeModal}
        annualSaving={annualSaving}
        onNavigate={handleNavigateFlow}
        onRestartFlow={handleRestartFlow}
        showSavingsFlowButton={showSavingsFlowButtonInRefundModal}
        onStartSavingsFlow={handleStartSavingsFlow}
      />

      <RefundAmountModal
        isOpen={isRefundAmountModalOpen}
        onClose={closeModal}
        refund={lastRefundFromApiRef.current ?? completedRefundAmount ?? refund}
        annualSaving={annualSaving}
        refundYears={refundYears}
        exactAmount={activeFlowId === REFUND_FLOW_ID}
        onNavigate={() => {
          setIsRefundAmountModalOpen(false);
          lastRefundFromApiRef.current = null;
          setCompletedRefundAmount(null);
          setTimeout(() => setIsSuggestionTaxSavingOpen(true), 300);
        }}
      />

      <AppInstallModal
        isOpen={isAppInstallModalOpen}
        onClose={handleCloseAppInstallModal}
      />

      <SuggestionTaxSavingModal
        isOpen={isSuggestionTaxSavingOpen}
        onClose={closeModal}
        onStart={handleStartSavingsFlow}
        onSkip={() => {
          setIsSuggestionTaxSavingOpen(false);
          setTimeout(() => setIsAppInstallModalOpen(true), 300);
        }}
        isLoading={isSuggestionStartLoading}
      />
    </>
  );
};

export default QuestionsPage;
